import FirmwarePage from './FirmwarePage';

export default FirmwarePage;
